module.exports = __webpack_public_path__ + "static/img/CL.2193593c.svg";